// extracted by mini-css-extract-plugin
module.exports = {"form-wrapper":"form-wrapper-with-buttons__form-wrapper___174w6","labels":"form-wrapper-with-buttons__labels___juIFj","buttons":"form-wrapper-with-buttons__buttons___2D1Cv"};